import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";
import type { StoreObjectType } from "owa-graph-schema";

export interface OnNewFolderNotificationActionMessage {
    folderId: string;
    parentFolderId: string;
    displayName: string;
    unreadCount: number;
    totalCount: number;
    updateMRUList: boolean;
    mailboxInfo: MailboxInfo | undefined;
    sortPosition: string | null;
    sortParentId: string | null;
}
export const onNewFolderNotification: (folderId: string, parentFolderId: string, displayName: string, unreadCount: number | undefined, totalCount: number | undefined, updateMRUList: boolean | undefined, sortPosition: string | null, sortParentId: string | null, mailboxInfo?: MailboxInfo) => OnNewFolderNotificationActionMessage = action("onNewFolderNotification", (folderId: string, parentFolderId: string, displayName: string, unreadCount: number = 0, totalCount: number = 0, updateMRUList: boolean = true, sortPosition: string | null, sortParentId: string | null, mailboxInfo?: MailboxInfo): OnNewFolderNotificationActionMessage => ({
    folderId,
    parentFolderId,
    displayName,
    unreadCount,
    totalCount,
    updateMRUList,
    mailboxInfo,
    sortPosition,
    sortParentId,
}));

export interface OnUpdateFolderNotificationActionMessage {
    unreadCount: number;
    totalCount: number;
    folderId: string;
    displayName: string;
    parentFolderId: string;
    sortPosition: string | null;
    sortParentId: string | null;
    folderType: StoreObjectType | null;
}
export const onUpdateFolderNotification: (unreadCount: number, totalCount: number, folderId: string, displayName: string, parentFolderId: string, sortPosition: string | null, sortParentId: string | null, folderType: StoreObjectType | null) => OnUpdateFolderNotificationActionMessage = action("onUpdateFolderNotification", (unreadCount: number, totalCount: number, folderId: string, displayName: string, parentFolderId: string, sortPosition: string | null, sortParentId: string | null, folderType: StoreObjectType | null): OnUpdateFolderNotificationActionMessage => {
    return {
        unreadCount,
        totalCount,
        folderId,
        displayName,
        parentFolderId,
        sortPosition,
        sortParentId,
        folderType,
    };
});
